<template>
  <modal 
    name="confirm-registration-modal" 
    :pivotY="0.2"
    :height="'auto'"
    width="90%" 
    :maxWidth="600" 
    :adaptive="true">
    
    <div class="border-b p-4 overflow-hidden">
      <div class="text-xl font-light float-left">
        Hello there {{ this.$store.state.brokerModule.broker.first_name }}!
      </div>

      <div class="float-right">
        <a href="#"
          v-on:click.prevent="$modal.hide('confirm-registration-modal')"
          class="text-grey hover:text-grey-darker">
          <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
            <use xlink:href="/img/feather-sprite.svg#x"/>
          </svg>
        </a>
      </div>
    </div>
    
    <div class="p-4">

      <div class="text-base leading-relaxed">
        We are very excited to have you onboard and can't wait to get you started with {{ getAppName }}!
        Please confirm your email address by clicking on the link in the email we sent. 
        If there is any issue, please 
        <a href="mailto:info@brokerpad.com.au" class="text-blue-600 underline font-semibold">let us know</a> and we will look into this immediately.
      </div>

      <div class="mt-3 text-base leading-relaxed">
        We have prepared a series of videos to help you get started with {{ getAppName }}.
        You can watch the introduction video below and also check out all the other videos in our
        <router-link :to="{ name  : 'help-home' }" tag="a" class="text-blue-500 font-semibold underline">Help Centre</router-link>.
      </div>

      <div class="mt-6 ml-8">
        <iframe 
          width="500px" 
          height="285px" 
          src="https://www.youtube.com/embed/6gk3vzssh8E?rel=0" 
          frameborder="0" 
          allowfullscreen></iframe>
      </div>

      <div class="mt-8 text-left">
        <SubmitButton label="Got it!" :onClick="submit" :loading="loading"></SubmitButton>
      </div>

    </div>
  </modal>
</template>

<script>
  import SubmitButton from '@/shared/components/form/SubmitButton'

  export default {

    components : {
      SubmitButton
    },

    data() {
      return {
        domain    : null,
        createWhat: null,
        loading   : false
      }
    },

    methods : {
      submit() {
        if(this.$route.params.showConfirmRegistration != null) {
          this.loading = true
          this.$modal.hide('confirm-registration-modal')
          this.$router.push({
            name: 'broker-home', 
          })
        }

        else {
          this.$modal.hide('confirm-registration-modal')
        }
      }
    }
  }
</script>